<template>
  <div class="menu">
    <template v-for="item in navMenus">
      <el-menu-item v-if="!item.children && !item.hidden" :index="item.path" :key="item.path">{{ item.meta.title }}</el-menu-item>
      <el-submenu v-if="item.children && !item.hidden" :key="item.path" :index="item.path">
        <template slot="title">
          <i :class="item.meta.icon"></i>
          <span> {{ item.meta.title }}</span>
        </template>
        <top-Bar :navMenus="item.children" />
      </el-submenu>
    </template>
  </div>
</template>
<script>
export default {
  name: "topBar",
  props: {
    navMenus:{
      type:Array
    }
  },
  data() {
    return {
    };
  },
  created() {
   
  },
  computed: {
  
  },
  methods: {
   
  },
};
</script>
<style lang="scss" scoped>
 
</style>